import globalWin from '@/utils/globalWin';
import authAjax from '@/utils/authajax';

import { customEventFunAttr, customEventTypeAttr } from './event';
import { MsgOrder, MsgStatus } from '@/components/MixinSendMsg';
import { IMSDK, SDKUtils } from '@/imsdk';

// xml脚本执行默认全局环境
export const xmlGlobalEnv = {
  Msg(ctx) {
    // 暂时什么都不需要做，直接兼容以前的写法返回内部这个对象就行
    return ctx;
  },
  // 这个请求方法主要给之前的xml脚本兼容使用，后面可以考虑废弃
  $: {
    ajax(options) {
      const { url, type, data = {}, success = () => {}, error = () => {} } = options;
      authAjax[type.toLowerCase()](url, data)
        .then(res => success(res))
        .catch(err => error(err));
    },
  },
  qd: {
    action: {
      // c2b发送消息方法
      sendC2B(ctx, actionData) {
        // 目前只有xml类型发送，后面有其他类型可以在里面加逻辑
        globalWin.sendQDXMLMessage({
          qdxml: {
            content: actionData.data.xml,
          },
        });
      },
      // b2c发送消息方法（仅仅上屏而已，模拟的b2c发送，不会进入消息轨迹或者历史记录，刷新就没了）
      sendB2C(ctx, actionData) {
        globalWin.addMessageList({
          type: IMSDK.TYPES.MSG_QDXML,
          status: MsgStatus.Success,
          time: Date.now(),
          to: (globalWin.wpaDetail || {}).kfuin || 0,
          seq: SDKUtils.generateUUID(),
          content: {
            path: '',
            brief: '',
            content: actionData.data.xml,
          },
        }, MsgOrder.Sync, false);
      },
    },
  },
};

/**
 * 为义转换为html的xml数据绑定默认的交互操作。如果 折叠菜单展开等。
 * @param {*} $dom
 * @param vDom 虚拟dom结构
 * @param {*} scriptStr 用于执行的脚本字符串
 * @param xmlLocalEnv 混入当前xml脚本执行环境对象，用于在特定当前的脚本中使用
 */
export function bindXMLEvent($dom, vDom, scriptStr, xmlLocalEnv) {
  /**
   * 构建xml脚本执行环境
   */
  const xmlEnv = Object.assign({}, xmlGlobalEnv, xmlLocalEnv);

  /**
   * 构建xml脚本执行函数
   */
  // 一些能在script直接使用的全局变量名
  const shorthandParams = Object.keys(xmlEnv);

  const fnParams = ['window', ...shorthandParams];
  const fnBody = [`return ${scriptStr.trim() || '{}'}`];
  // eslint-disable-next-line no-new-func
  const fn = new Function(...[...fnParams, ...fnBody]);

  /**
   * 执行xml脚本得到xml上下文
   */
  const shorthandValues = shorthandParams.map(key => xmlEnv[key]);
  const xmlCtx = fn(xmlEnv, ...shorthandValues);

  bindFold($dom);
  bindEvent($dom, vDom, xmlCtx);
}

// 展开/折叠
function bindFold($dom) {
  const clz = 'msg-xml-fold';
  const clzExpand = 'expand';
  const folds = $dom.querySelectorAll(`.${clz}`);

  function action(e) {
    const item = e.currentTarget.parentNode;

    if (item.className.indexOf(clzExpand) > -1) {
      // eslint-disable-next-line no-param-reassign
      item.className = item.className.replace(clzExpand, '');
    } else {
      // eslint-disable-next-line no-param-reassign
      item.className = `${item.className} ${clzExpand}`;
    }
  }

  folds.forEach((item) => {
    const handler = item.querySelector(':first-child');
    handler.removeEventListener('click', action);
    handler.addEventListener('click', action, false);
  });
}

function bindEvent($dom, vDom, xmlCtx) {
  const { props, children } = vDom;

  const { type, fun } = props.action || {};
  if (type && fun) {
    // 这里通过querySelectorAll来获取所有事件类型和事件函数相同的dom节点
    const targetDomList = $dom.querySelectorAll(`[${customEventTypeAttr}="${type}"][${customEventFunAttr}="${fun}"]`);
    targetDomList.forEach((targetDom) => {
      // 注意一定要先移除再添加，否则当存在多个相同事件类型和事件函数的dom节点时，通过vDom遍历会出现事件重复绑定的问题
      targetDom.removeEventListener(type, xmlCtx[fun]);
      targetDom.addEventListener(type, xmlCtx[fun], false);
    });
  }

  // 递归添加事件
  children.forEach(child => bindEvent($dom, child, xmlCtx));
}
